export default "__VITE_ASSET__24209c47__"